import type { CoreApiClient } from "../client";
import type {
  CreateValveRequestBody,
  ReconcileValvesRequestBody,
  UpdateValvesRequestBody,
  Valve,
} from "../types/valve.type";

export const createValveMutations = (api: CoreApiClient) => {
  const { request } = api;

  /** Create a single valve. The add dialog fans this out over its staged valves. */
  const create = async (buildingId: string, body: CreateValveRequestBody): Promise<Valve> => {
    const { data } = await request("post", "/buildings/{buildingId}/valves", {
      params: { path: { buildingId } },
      body,
    });
    return data;
  };

  /** Atomically apply a pre-install change-set (`{ create, update, deleteValve }`) in one transaction. */
  const reconcile = async (buildingId: string, body: ReconcileValvesRequestBody): Promise<void> => {
    await request("patch", "/buildings/{buildingId}/valves/preinstall", {
      params: { path: { buildingId } },
      body,
    });
  };

  const update = async (buildingId: string, body: UpdateValvesRequestBody): Promise<void> => {
    await request("patch", "/buildings/{buildingId}/valves", {
      params: { path: { buildingId } },
      body,
    });
  };

  const deleteValve = async (buildingId: string, valveId: string): Promise<void> => {
    await request("delete", "/buildings/{buildingId}/valves/{valveId}", {
      params: { path: { buildingId, valveId } },
    });
  };

  /** Relay a rod-stroke learning command to the gateway; it triggers within the next 15 minutes. */
  const relaunchLearning = async (buildingId: string, valveId: string): Promise<void> => {
    await request("post", "/buildings/{buildingId}/valves/{valveId}/relaunch-learning", {
      params: { path: { buildingId, valveId } },
    });
  };

  return {
    create,
    reconcile,
    update,
    delete: deleteValve,
    relaunchLearning,
  };
};
